
import { Component, Prop, Vue, } from 'vue-property-decorator';
import { FeedbackColours, FeedbackColoursType, isFeedbackColour, } from '~/utils/resources';

@Component
export default class FeedbackBox extends Vue {

	@Prop({
		type: Boolean,
		required: false,
		default: true,
	})
	icon!: boolean;

	@Prop({
		type: String,
		required: true,
		validator(value) {
			return isFeedbackColour(value);
		},
	})
	status!: FeedbackColoursType;

	@Prop({
		type: String,
		required: true,
	})
	title!: string;

	@Prop({
		type: Boolean,
		required: false,
	})
	alignIconVerticalCenter!: boolean;

	@Prop({
		type: String,
		required: false,
	})
	iconName!: string;

	get computedIcon() {
		if (this.icon === true) {
			return this.iconName || FeedbackColours[this.status].icon;
		} else {
			return null;
		}
	}
}
